// document.addEventListener('DOMContentLoaded', function () {
//   const badgePopup = document.getElementById('badge-popup');
//   if(!badgePopup) { return }
//   const slideContainer = badgePopup.querySelector('.badge-slide-container');
//   const closeBtn = badgePopup.querySelector('.close-popup');
//   const nextBtn = badgePopup.querySelector('.next-slide');
//   const prevBtn = badgePopup.querySelector('.prev-slide');
//   const slideNumberDisplay = badgePopup.querySelector('.slide-number');
//   let currentSlideIndex = 0;
//   let visibleSlides = [];

//   // **Event Delegation Kullanarak Click Eventini Yakala**
//   document.addEventListener('click', function (event) {
//     const icon = event.target.closest('.chloe-icon'); // En yakın .chloe-icon'u bul
//     if (!icon) return; // Eğer tıklanan element bir badge değilse çık

//     const badgeType = icon.getAttribute('data-name');
//     const badgeDescription = icon.getAttribute('data-description');
//     const badgeButtonName = icon.getAttribute('data-button-name');
//     const badgeButtonLink = icon.getAttribute('data-button-link');
//     const badgeImageSrc = icon.querySelector('img').src;

//     visibleSlides = Array.from(document.querySelectorAll('.chloe-icon')).map(icon => {
//       return {
//         name: icon.getAttribute('data-name'),
//         title: icon.getAttribute('data-name'),
//         description: icon.getAttribute('data-description'),
//         buttonName: icon.getAttribute('data-button-name'),
//         buttonLink: icon.getAttribute('data-button-link'),
//         imageSrc: icon.querySelector('img').src
//       };
//     });

//     badgePopup.style.display = 'flex';
//     createSlides();
//     currentSlideIndex = visibleSlides.findIndex(slide => slide.name === badgeType);
//     showSlide(currentSlideIndex);
//   });

//   // Slaytları oluşturma fonksiyonu
//   const createSlides = () => {
//     slideContainer.innerHTML = '';
//     visibleSlides.forEach((slideData, index) => {
//       const slide = document.createElement('div');
//       slide.className = 'badge-slide';
//       if (index === 0) slide.classList.add('active');
//       slide.innerHTML = `
//         <div class="slide-image">
//           <img src="${slideData.imageSrc}" alt="${slideData.name} icon" />
//         </div>
//         <h2 class="slide-title">${slideData.title}</h2>
//         <p class="slide-description">${slideData.description}</p>
//         <a href="${slideData.buttonLink}" class="discover-more">${slideData.buttonName}</a>
//       `;
//       slideContainer.appendChild(slide);
//     });
//     updateSlideNumber(visibleSlides.length);
//   };

//   // Kapatma butonu
//   closeBtn.addEventListener('click', () => {
//     badgePopup.style.display = 'none';
//   });

//   // Slayt geçişleri
//   nextBtn.addEventListener('click', () => {
//     if (visibleSlides.length > 1) {
//       currentSlideIndex = (currentSlideIndex + 1) % visibleSlides.length;
//       showSlide(currentSlideIndex);
//     }
//   });

//   prevBtn.addEventListener('click', () => {
//     if (visibleSlides.length > 1) {
//       currentSlideIndex = (currentSlideIndex - 1 + visibleSlides.length) % visibleSlides.length;
//       showSlide(currentSlideIndex);
//     }
//   });

//   const showSlide = (index) => {
//     const slides = slideContainer.querySelectorAll('.badge-slide');
//     slides.forEach((slide, i) => {
//       slide.classList.remove('active', 'prev', 'next');
//       if (i === index) {
//         slide.classList.add('active');
//       } else if (i < index) {
//         slide.classList.add('prev');
//       } else {
//         slide.classList.add('next');
//       }
//     });
//     updateSlideNumber(slides.length);
//   };

//   const updateSlideNumber = (totalSlides) => {
//     slideNumberDisplay.textContent = `${currentSlideIndex + 1}/${totalSlides}`;
//   };

//   // **MutationObserver Kullanarak Yeni Yüklenen Ürünlerdeki Badge’leri Takip Et**
//   const observer = new MutationObserver(mutations => {
//     mutations.forEach(mutation => {
//       if (mutation.type === 'childList') {
//         mutation.addedNodes.forEach(node => {
//           if (node.nodeType === 1 && node.matches('.product-item')) { // Shopify ürün elementi
//             initializeBadges(node);
//           }
//         });
//       }
//     });
//   });

//   // Sonsuz kaydırmada yeni elemanlar eklendikçe takip et
//   observer.observe(document.body, { childList: true, subtree: true });

//   // Yeni eklenen elemanları işle
//   const initializeBadges = (parent = document) => {
//     parent.querySelectorAll('.chloe-icon').forEach(icon => {
//       if (!icon.hasAttribute('data-initialized')) {
//         icon.setAttribute('data-initialized', 'true');
//       }
//     });
//   };

//   // Sayfa ilk yüklendiğinde mevcut badge'leri işleyelim
//   initializeBadges();
// });
document.addEventListener('DOMContentLoaded', function () {

  const badgePopup = document.getElementById('badge-popup');
  if (!badgePopup) return;

  const slideContainer = badgePopup.querySelector('.badge-slide-container');
  const closeBtn = badgePopup.querySelector('.close-popup');
  const nextBtn = badgePopup.querySelector('.next-slide');
  const prevBtn = badgePopup.querySelector('.prev-slide');
  const slideNumberDisplay = badgePopup.querySelector('.slide-number');

  let currentSlideIndex = 0;
  let visibleSlides = [];

  document.addEventListener('click', function (event) {

    const clickedBadge = event.target.closest('.chloe-icon');
    if (!clickedBadge) return;

    // Only collect badges from the same product
    const badgeWrapper = clickedBadge.closest('.iconWrapper');
    if (!badgeWrapper) return;

    // Remove duplicate badges
    const uniqueBadges = new Map();

    badgeWrapper.querySelectorAll('.chloe-icon').forEach(icon => {

      const key = icon.dataset.name;

      if (!uniqueBadges.has(key)) {
        uniqueBadges.set(key, {
          name: icon.dataset.name,
          title: icon.dataset.name,
          description: icon.dataset.description,
          buttonName: icon.dataset.buttonName,
          buttonLink: icon.dataset.buttonLink,
          imageSrc: icon.querySelector('img').src
        });
      }

    });

    visibleSlides = [...uniqueBadges.values()];

    currentSlideIndex = visibleSlides.findIndex(
      slide => slide.name === clickedBadge.dataset.name
    );

    badgePopup.style.display = 'flex';

    createSlides();

    showSlide(currentSlideIndex);

  });

  function createSlides() {

    slideContainer.innerHTML = '';

    visibleSlides.forEach((slideData) => {

      const slide = document.createElement('div');

      slide.className = 'badge-slide';

      slide.innerHTML = `
        <div class="slide-image">
          <img src="${slideData.imageSrc}" alt="${slideData.title}">
        </div>

        <h2 class="slide-title">${slideData.title}</h2>

        <p class="slide-description">${slideData.description}</p>

        ${
          slideData.buttonLink
            ? `<a href="${slideData.buttonLink}" class="discover-more">${slideData.buttonName}</a>`
            : ''
        }
      `;

      slideContainer.appendChild(slide);

    });

  }

  function showSlide(index) {

    const slides = slideContainer.querySelectorAll('.badge-slide');

    slides.forEach((slide, i) => {

      slide.classList.remove('active', 'prev', 'next');

      if (i === index) {
        slide.classList.add('active');
      } else if (i < index) {
        slide.classList.add('prev');
      } else {
        slide.classList.add('next');
      }

    });

    slideNumberDisplay.textContent = `${index + 1}/${slides.length}`;

  }

  nextBtn.addEventListener('click', function () {

    if (visibleSlides.length <= 1) return;

    currentSlideIndex++;

    if (currentSlideIndex >= visibleSlides.length) {
      currentSlideIndex = 0;
    }

    showSlide(currentSlideIndex);

  });

  prevBtn.addEventListener('click', function () {

    if (visibleSlides.length <= 1) return;

    currentSlideIndex--;

    if (currentSlideIndex < 0) {
      currentSlideIndex = visibleSlides.length - 1;
    }

    showSlide(currentSlideIndex);

  });

  closeBtn.addEventListener('click', function () {
    badgePopup.style.display = 'none';
  });

});